import { Select, Input, DatePicker, Button } from 'antd';
const { RangePicker } = DatePicker;
export const ThirdPartyCalculationColumns  = (billingInvoiceNames, customerUidData, setSurchargeModalOpen, setSurchargeModalContent) => [
    {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Select
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    placeholder="请选择"
                    allowClear
                    options={[
                        { label: '待计算', key: '4', value: '4' },
                        { label: '计费异常', key: '5', value: '5' },
                        { label: '待出账', key: '6', value: '6' },
                        { label: '已出账', key: '7', value: '7' },
                    ]}
                    />
            )
        },
    },
    {
        title: 'Tracking Number',
        dataIndex: 'tracking_number',
        key: 'tracking_number',
        search: true,
        renderFOrmItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Input
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    placeholder="请输入（支持模糊查询）"
                />
            )
        },
    },
    {
        title: 'Master Tracking',
        dataIndex: 'master_tracking_number',
        key: 'master_tracking_number',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Input
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    placeholder="请输入（支持模糊查询）"
                />
            )
        },
    },
    {
        title: 'UID',
        dataIndex: ['customer', 'uid'],
        key: 'uid',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Select
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    allowClear
                    placeholder="请选择"
                    options={customerUidData?.map((item) => ({
                        label: item.uid,
                        key: item.id,
                        value: item.id
                    }))}
                    showSearch
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                />
            )
        }
    },
    {
        title: '费用',
        dataIndex: ['fee_json', 'total'],
        key: 'fee_json',
        search: false,
        render: (text, record) => {
            if (record.status === "待出账" || record.status === "已出账"){
                return <Button type="link" onClick={() => {
                    const newModalContent = Object.entries(record.fee_json).map(([key, value], index) => ({
                        key: index,
                        type: key,
                        amount: value
                    }));
                    setSurchargeModalContent(newModalContent);
                    setSurchargeModalOpen(true);
                }}>
                    {text}
                </Button>
            } else {
                return text;
            }
        }
    },
    {
        title: 'Shipment Date',
        dataIndex: 'shipment_date',
        key: 'shipment_date',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return <RangePicker />
        },
    },
    {
        title: '渠道',
        dataIndex: 'logistics_service_supplier',
        key: 'logistics_service_supplier',
        search: false,
    },
    {
        title: '物流服务',
        dataIndex: 'service_type',
        key: 'service_type',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Input
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    placeholder="请输入（支持模糊查询）"
                />
            )
        },
    },
        {
        title: '导入批次编号',
        dataIndex: ['billing_invoice', 'name'],
        key: 'billing_invoice',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Select
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    allowClear
                    placeholder="请选择"
                    options={billingInvoiceNames?.map((item) => ({
                        label: item.name,
                        key: item.id,
                        value: item.id
                    }))}
                    showSearch
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                />
            )
        }
    },
    {
        title: '出账批次',
        dataIndex: ['invoice', 'name'],
        key: 'invoice',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Select
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    placeholder="请选择"
                    allowClear
                    options={billingInvoiceNames?.map((item) => ({
                        label: item.name,
                        key: item.id,
                        value: item.id
                    }))}
                    showSearch
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                />
            )
        }
    },
    {
        title: 'Rated Weight',
        dataIndex: 'rated_weight',
        key: 'rated_weight',
        search: false,
    },
    {
        title: 'Zone',
        dataIndex: 'zone_code',
        key: 'zone_code',
        search: false,
    },
    {
        title: '计费异常',
        dataIndex: 'calculation_error',
        key: 'calculation_error',
        search: false,
    }
]